import { createSelector } from "@reduxjs/toolkit";
export const selectRootUndoRedo = (state) => state.undoRedo;
export const selectUndoRedoAvailability = createSelector(selectRootUndoRedo, ({ currentRevision, revisions }) => ({
  isUndoAvailable: currentRevision > 0,
  isRedoAvailable: currentRevision < revisions.length - 1
}));
